<template>
  <div ref="content" :dir="textDirection">
    <!-- Q: Why are we setting the direction here?
         A: The map this popup is nested inside may have overridden the direction, so we need to ensure
            that the content of our popup is going the right direction. -->
    <popup-content v-if="points.length === 1" :data-loaded="dataLoaded" :point-details="pointsDetails[0] || {}" />
    <combined-popup-content v-else :data-loaded="dataLoaded" :points="points" :points-details="pointsDetails" />
  </div>
</template>

<script>
import CombinedPopupContent from './combined-popup-content'
import { mapGetters, mapState } from 'vuex'
import { nextTick } from 'vue'
import { Popup } from 'maplibre-gl'
import PopupContent from './popup-content'

export default {
  components: { CombinedPopupContent, PopupContent },

  props: {
    map: {
      type: Object,
      required: true
    },
    points: {
      type: Array,
      required: true
    }
  },

  emits: ['close'],

  data() {
    return {
      mglPopup: null
    }
  },

  computed: {
    ...mapGetters(['detailsForIds']),
    ...mapState(['locationDetailsLookup']),

    coordinates() {
      return [this.points[0].lon, this.points[0].lat]
    },
    dataLoaded() {
      return !!this.locationDetailsLookup[JSON.stringify(this.pointsIdsTypes)]
    },
    pointsDetails() {
      return this.detailsForIds(this.pointsIdsTypes) || []
    },
    pointsIdsTypes() {
      return this.points.map(singlePoint => ({id: singlePoint.id, type: singlePoint.type}))
    },
    textDirection() {
      return this.i18n.isRtl() ? 'rtl' : 'ltr'
    }
  },

  watch: {
    dataLoaded() {
      nextTick(() => {
        // Tell the Popup to recalculate which way it should go, now that the size of the
        // DOM element we've set as its content may have changed.
        this.mglPopup._update()
      })
    }
  },

  mounted() {
    this.mglPopup = new Popup()
    this.mglPopup.setLngLat(this.coordinates)
    this.mglPopup.setDOMContent(this.$refs.content)
    this.mglPopup.addTo(this.map)
    this.loadPopupData()

    this.mglPopup.on('close', () => {
      this.$emit('close')
    })
  },

  methods: {
    loadPopupData() {
      if (!this.dataLoaded) {
        this.$store.dispatch('getLocationDetails', this.pointsIdsTypes)
      }
    }
  }
}
</script>
